import styled from "styled-components";

export const AssetsContent = styled.div.attrs({})`
  margin: 24px 0 32px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 16px 0px #00000029;
`;
export const AssetsContentItem = styled.div.attrs({})`
  padding: 16px 0px 16px 16px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);  
  align-items: center;
  border-bottom: 1px solid ${(p) => p.theme.palette.colors.borderline};
  &:last-child {
    border: 0;
  }
`;
export const AssetsContentItemContent = styled.div.attrs({})`
  display: flex;
  grid-start: 1;
  align-items: center;
  gap: 16px;
`;
export const AssetsContentItemIcon = styled.div.attrs({})`
  width: 38px;
  height: 38px;
  background: url(/icons/document.svg) no-repeat center center / cover;
  border-radius: 8px;
`;
export const AssetsContentItemText = styled.div.attrs({})`
  font-size: 14px;
  color: rgba(83, 57, 227, 1);
  cursor: pointer;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 230px;
`;
export const AssetsContentItemAction = styled.div.attrs({})`
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    transform: scale(1.05);
  }
`;
export const AssetsContentItemFlexBox = styled.div.attrs({})`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  padding: 0 0 0 12px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const AssetsContentItemDetails = styled.p.attrs({})`
  @media (max-width: 768px) {
    display: none;
  }
`;

export const AssetsContentItemActionIcon = styled.img.attrs({
  src: "/icons/trash.svg",
  width: 16,
})``;
export const AssetsContentItemActionIconDownload = styled.img.attrs({
  src: "/icons/cloud-download.svg",
  width: 16,
})``;

export const CardHomeContentLabel = styled.div.attrs({})`
  padding: 5px 16px 5px 8px;
  background: ${(props) =>
    props.isSuccess === undefined || props.isSuccess === null
      ? props.theme.palette.colors.purpleLight
      : props.isSuccess
        ? props.theme.palette.colors.greenLight
        : props.theme.palette.colors.redLight};
  border-radius: 32px;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    padding: 5px 8px 5px 8px;
  }
`;
export const CardHomeContentLabelDecoration = styled.img.attrs((props) => ({
  src:
    props.isSuccess === undefined || props.isSuccess === null
      ? "/icons/info.svg"
      : props.isSuccess
        ? "/icons/approved.svg"
        : "/icons/refused.svg",
}))`
  width: 13px;
  height: 13px;
  margin: 0 8px 0 0;
`;
export const CardHomeContentLabelText = styled.div.attrs({})`
  font-size: 14px;
  color: ${(props) =>
    props.isSuccess === undefined || props.isSuccess === null
      ? props.theme.palette.colors.blue
      : props.isSuccess
        ? props.theme.palette.colors.green
        : props.theme.palette.colors.red};

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;
